'use client';

import { useEffect } from 'react';

import { cn } from '@/lib/utils';
import { LoadingState } from '@/types/common';

import { BrandLoader } from './brand-loader';

interface LoadingOverlayProps extends Partial<LoadingState> {
  message?: string;
  className?: string;
  showErrorInOverlay?: boolean;
}

export function LoadingOverlay({
  isLoading = false,
  error,
  message,
  className,
  showErrorInOverlay = false,
}: LoadingOverlayProps) {
  // ローディング中はスクロールを無効化
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isLoading]);

  if (!isLoading) return null;

  const showOverlay = isLoading || (showErrorInOverlay && error);

  if (!showOverlay) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/40 transition-all duration-300',
        className
      )}
    >
      {isLoading && (
        <BrandLoader width={220} message={message} messageClassName="text-gray-600" />
      )}
      {showErrorInOverlay && error && !isLoading && (
        <div className="text-center">
          <div className="text-red-500 text-lg font-medium mb-2">エラーが発生しました</div>
          <p className="text-gray-600 text-sm max-w-md">{error}</p>
        </div>
      )}
    </div>
  );
}
